import { render, staticRenderFns } from "./titulos-publicos.vue?vue&type=template&id=5dd1463e&scoped=true&"
import script from "./titulos-publicos.vue?vue&type=script&lang=js&"
export * from "./titulos-publicos.vue?vue&type=script&lang=js&"
import style0 from "./titulos-publicos.vue?vue&type=style&index=0&id=5dd1463e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1463e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd1463e')) {
      api.createRecord('5dd1463e', component.options)
    } else {
      api.reload('5dd1463e', component.options)
    }
    module.hot.accept("./titulos-publicos.vue?vue&type=template&id=5dd1463e&scoped=true&", function () {
      api.rerender('5dd1463e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/RendaFixa/titulos-publicos.vue"
export default component.exports